import React__default from 'react';
import { initialState } from './helper/intitalState.js';
import locale from './locale/wmLocale.js';
import dayjs from 'dayjs';
import CONSTANT from './helper/constant.js';

var DvCalendarContext = /*#__PURE__*/React__default.createContext({
  userSelection: initialState,
  showWk: false,
  showWalCal: false,
  rangeSelection: true,
  rangeField: CONSTANT.START,
  showWeekNumber: true,
  locale: locale,
  cbSetDateRange: function cbSetDateRange() {},
  style: {
    monthLabel: {
      fontSz: 12
    },
    box: {
      fontSz: 40
    },
    calendar: {
      gap: 20
      // boxSz: 0,
    },

    weekSeries: {
      gap: 20
    }
  },
  minMax: {
    min: dayjs(),
    max: dayjs()
  },
  hideNextMonth: false
});

export { DvCalendarContext };
